<div class="modal-overlay"></div>
<div class="modal-container" role="dialog" aria-modal="true">
  <button type="button" class="closeBtn" aria-label="Close" (click)="close()">
    <app-icon icon="close" class="large-icon"></app-icon>
  </button>
  <form [formGroup]="formReason" class="d-flex flex-column w-100">
    <div class="modal-header border-0 d-flex align-items-start px-4 pt-4 pb-0">
      <div class="modal-title large-bold-text">Are you sure you want to Blacklist this {{typeName}}?</div>
    </div>
    <div class="modal-body d-flex flex-column gap-4 px-4 py-4">
      <div class="small-reg-text">{{subtext}}</div>
      <div class="input-wrapper d-flex flex-column gap-1">
        <label for="reasonTextArea" id="reasonLabel">Reason</label>
        <textarea id="reasonTextArea" class="custom-input text-area w-100 mw-100" placeholder="Type your reason..."
        aria-labelledby="reasonLabel" formControlName="reason" maxlength="1000"></textarea>
      </div>
      @if (isLeadSupervisor) {
        <div class="search-results d-flex flex-column gap-2">
          <div class="title medium-bold-text">Select New Lead Supervisor</div>
          <div class="small-reg-text">{{subtext2}}</div>
          <app-supervisor-search class="d-block w-100 mt-3" (searchResults)="onSearchResults($event)" [(keywords)]="textFilter" [(showInactive)]="showInactive"></app-supervisor-search>
          @if (filteredSupervisors) {
            <div class="sup-list-wrapper d-flex flex-column overflow-auto">
              @for (supervisor of filteredSupervisors; track supervisor) {
                <div>
                  <app-supervisor-info-card [supervisor]="supervisor"
                    [viewType]="'sup-list-add'"
                    [isSelected]="isSelected(supervisor)"
                    (click)="selectSupervisor(supervisor)">
                  </app-supervisor-info-card>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
    <div class="modal-footer border-0 px-4 pt-0 pb-4">
      <div class="d-flex flex-column flex-sm-row gap-3 w-100 m-0">
        <button type="button" class="custom-button-large-secondary w-100 m-0" (click)="close()">No</button>
        <button type="button" class="custom-button-large-primary-red w-100 m-0" [disabled]="isFormInValid()" [matTooltip]="formReason.invalid ? 'You must provide a reason.' : ''" (click)="emitBlacklistReasonEvent()">Yes</button>
      </div>
    </div>
  </form>
</div>
